// extracted by mini-css-extract-plugin
export default {"card1":"wvRLqts3","_type1":"pKn9kFym","mobile":"mobile","image":"UUY6ZwEs","link":"zqmHqOvi","icon":"cqeMgYIo","rubric":"YevzVelK","time":"PYLCLnKV","desktop":"desktop"};